import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onResetFilter }) => {
    return (
        <div className="flex flex-col items-center justify-center py-16 md:py-24 px-4">
            <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-full bg-muted flex items-center justify-center mb-6">
                <Icon
                    name="SearchX"
                    size={40}
                    className="text-muted-foreground"
                    strokeWidth={1.5}
                />
            </div>

            <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-2 text-center">
                No Vendors Found
            </h2>

            <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
                We couldn't find any vendors matching your selected category. Try browsing other categories or check back later.
            </p>

            <Button
                variant="outline"
                iconName="RotateCcw"
                iconPosition="left"
                onClick={onResetFilter}
            >
                View All Categories
            </Button>
        </div>
    );
};

export default EmptyState;